import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    width: 100%;
    line-height: 1.33;
`;

export const Body = styled.div`
    background-color: ${COLORS.white};
    border-bottom: 1px solid ${COLORS.grey};
    color: ${COLORS.black};
    padding: 20px 18px;
    @media(min-width: 768px) {
        padding-bottom: 25px;
        padding-top: 25px;
    }
`;

export const Footer = styled.div`
    background-color: ${COLORS.white};
    color: ${COLORS.darkGrey};
    ${FONTS.XS};
    padding: 14px 42px 18px;
    @media(min-width: 768px) {
        padding-top: 20px;
        padding-bottom: 30px;
    }

    @media(min-width: 1180px) {
        padding-top: 25px;
        padding-bottom: 25px;
    }
`;

export const ContentTitle = styled.h3`
    margin-bottom: 15px;
    @media(min-width: 768px) {
        ${FONTS.H4};
    }
`;

export const ContentText = styled.p`
    color: ${COLORS.black};
    margin: 20px 0 10px;
`;

export const ContentList = styled.ol`
    counter-reset: list;
`;

export const ContentListItem = styled.li`
    counter-increment: list;
    margin-bottom: 14px;
    padding-left: 25px;
    position: relative;
    @media(min-width: 768px) {
        margin-bottom: 20px;
    }
    &:last-child {
        margin-bottom: 0;
    }
    &::before {
        content: counter(list) ". ";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
`;
